import React from 'react';
import { SiteFooter } from './InfoPage';

export default function LegalPage() {
  return <><main className="info-page fade-in">
    <a href="#accueil">← Retour au site</a>
    <h1>Mentions légales</h1>
    <p className="info-lead">Les informations sur l’éditeur et l’hébergement de BrainteaserDay.</p>
    <section className="card">
      <h2>Éditeur</h2>
      <p>BrainteaserDay est édité à titre personnel par Valentin SAEZ, responsable de la publication.</p>
      <p>Contact : <a href="mailto:valentinsaez@yahoo.fr">valentinsaez@yahoo.fr</a>.</p>
    </section>
    <section className="card">
      <h2>Hébergement</h2>
      <p><strong>Site web : Vercel Inc.</strong><br/>440 N Barranca Avenue #4133, Covina, CA 91723, États-Unis.</p>
      <p><a href="https://vercel.com/legal/privacy-notice" target="_blank" rel="noreferrer">Coordonnées et informations légales de Vercel</a>.</p>
      <p><strong>Serveur et base de données : OVH SAS (OVHcloud).</strong><br/>2 rue Kellermann, 59100 Roubaix, France.</p>
      <p><a href="https://www.ovhcloud.com/fr/terms-and-conditions/" target="_blank" rel="noreferrer">Coordonnées et mentions légales d’OVHcloud</a>.</p>
    </section>
    <section className="card">
      <h2>Signalement et données personnelles</h2>
      <p>Pour signaler une erreur ou un contenu, utilise la <a href="#contact">page Contact</a>. Indique la date, le thème de l’énigme ou le message concerné pour faciliter son examen.</p>
      <p>La <a href="#confidentialite">politique de confidentialité</a> explique l’utilisation de tes données et l’exercice de tes droits. Les informations sur le navigateur sont disponibles dans la page <a href="#stockage-local">Cookies et stockage local</a>.</p>
    </section>
  </main><SiteFooter/></>;
}
